module.exports = __webpack_public_path__ + "static/media/Agile Product Engineering.b3f3f96d.png";